import { jsx as _jsx } from "react/jsx-runtime";
// Card: the kit's panel chrome (surface.css "Panels": .wp-now, .wp-step …) and its glass container
// for the HUD (.wp-glass, .wp-glass--strong). Put text on panel or strong glass; the lighter glass is
// for chrome that carries no text (mockups/CONTRACT.md 6.5).
import { cva } from "class-variance-authority";
import { cn } from "./cn.js";
export const cardVariants = cva("min-w-0 border font-sans text-14 leading-body text-wp-text", {
    variants: {
        surface: {
            panel: "rounded-12 border-wp-line bg-linear-to-b from-wp-panel-2/82 to-wp-panel/74",
            glass: [
                "rounded-16 border-wp-glass-border bg-wp-glass shadow-3",
                "backdrop-blur-wp-glass backdrop-saturate-115",
            ],
            "glass-strong": [
                "rounded-16 border-wp-glass-border bg-wp-glass-strong shadow-3",
                "backdrop-blur-wp-glass backdrop-saturate-115",
            ],
        },
        compact: {
            false: "p-3.5",
            true: "p-3",
        },
    },
    defaultVariants: { surface: "panel", compact: false },
});
export function Card({ className, surface, compact, ...props }) {
    return (_jsx("div", { "data-surface": surface ?? "panel", "data-compact": compact ?? false, className: cn(cardVariants({ surface, compact }), className), ...props }));
}
//# sourceMappingURL=card.js.map